module.exports = __webpack_public_path__ + "img/american-burger-app.fc500f6d.png";